<template>
  <div class="company-modal js-company-modal overlay-company-modal" @click="cancel()">
    <div class="company-modal__bg js-company-modal-close"></div>
    <div class="company-modal__content" @click="stopEvent()">
      <div class="company-modal__header">
        <a class="company-modal__close js-company-modal-close" @click="cancel()"></a>
      </div>
      <div class="l-headding is-blueline">法人切り替え</div>
      <div class="company-modal__search">
        <div class="l-inputBlock">
          <div class="l-inputAccount w-vshort">
            <TextBox v-model="searchForm.subordinateNum" placeholder="顧問先番号" name="searchSubordinateNum" ></TextBox>
          </div>
          <div class="l-inputAccount w-short">
            <TextBox v-model="searchForm.corpName" placeholder="法人名" name="searchCorpNm" ></TextBox>
          </div>
          <div>
            <label class="l-checkbox is-selected">
              <input type="checkbox" v-model="searchForm.isOnlyResponsible"> 表示設定した企業のみ
            </label>
          </div>
          <div>
            <div class="btn-basic is-inlne is-primary" @click="getFilteredCorporateListFromModal()"><a>絞り込み</a></div>
          </div>
        </div>
      </div>
      <div class="company-modal__list">
        <table class="table-base audit-table  table-select">
          <colgroup>
            <col style="width: 140px;">
            <col style="width: 300px;">
            <col>
          </colgroup>
          <thead>
            <tr class="is-sort">
              <th
                :class="getSortClass(searchForm.sortKey.isSortedBySubordinateNum)"
                @click="sortBySubordinateNum()"><span>顧問先番号</span></th>
              <th
                :class="getSortClass(searchForm.sortKey.isSortedByCorpNameKana)"
                @click="sortByCorpNameKana()"><span>法人名</span></th>
              <th
                :class="getSortClass(searchForm.sortKey.isSortedByResponsibleName)"
                @click="sortByResponsibleName()"><span>担当</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="corporate in corporateList" :key="corporate.corpId" @click="emitSelectCorporate(corporate)">
              <td>{{ corporate.corpAuthNo == 9 ? corporate.subordinateNum : '' }}</td>
              <td>{{ corporate.corpNm }}</td>
              <td>{{ corporate.responsibleName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';

export default {
  components: {
    TextBox
  },
  data() {
    return {
      corporateList: [
        {
          corpId: null,
          corpNm: '',
        }
      ],
      searchForm: {
        subordinateNum: null,
        corpName: null,
        isOnlyResponsible: false,
        sortKey: {
          isDefaultSort: true,
          isAscendingSort: true,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
        },
      },
    }
  },
  created: function () {
    this.getCorporateListFromModal();
  },
  methods: {
    async getCorporateListFromModal() {
      let res = await this.$axios.post('/ld/api/corporate/getCorporateListFromModal', {
        sortKey: this.searchForm.sortKey,
      });
      if (res) {
        this.corporateList = res.data.corporateList;
      }
    },
    async getFilteredCorporateListFromModal() {
      let res = await this.$axios.post('/ld/api/corporate/getFilteredCorporateListFromModal', {
        subordinateNum: this.searchForm.subordinateNum,
        corpNm: this.searchForm.corpName,
        isOnlyResponsible: this.searchForm.isOnlyResponsible,
        sortKey: this.searchForm.sortKey,
      });
      if (res) {
        this.corporateList = res.data.corporateList;
      }
    },
    emitSelectCorporate(corporate) {
      this.$emit("select-corporate", {
        corpId: corporate.corpId,
        corpNm: corporate.corpNm,
      });
      this.$emit("hide-corporate-list-modal");
    },
    cancel() {
      this.$emit("hide-corporate-list-modal");
    },
    stopEvent() {
      event.stopPropagation()
    },
    getSortClass(sortFlag) {
      let classStr = ''
      if (sortFlag) classStr += 'is-sorted ';
      if (sortFlag && this.searchForm.sortKey.isAscendingSort) classStr += 'is-ascending';
      if (sortFlag && !this.searchForm.sortKey.isAscendingSort) classStr += 'is-descending';
      return classStr;
    },

    isFiltering(searchForm) {
      return searchForm.subordinateNum != null
          || searchForm.corpName != null
          || searchForm.isOnlyResponsible == true
    },
    async sortBySubordinateNum() {
      if (this.searchForm.sortKey.isSortedBySubordinateNum) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: true,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateListFromModal();
      } else {
        await this.getCorporateListFromModal(1);
      }
    },
    async sortByCorpNameKana() {
      if (this.searchForm.sortKey.isSortedByCorpNameKana) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: true,
          isSortedByResponsibleName: false,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateListFromModal();
      } else {
        await this.getCorporateListFromModal(1);
      }
    },
    async sortByResponsibleName() {
      if (this.searchForm.sortKey.isSortedByResponsibleName) {
        this.searchForm.sortKey.isAscendingSort = !this.searchForm.sortKey.isAscendingSort;
      } else {
        this.searchForm.sortKey = {
          isDefaultSort: false,
          isAscendingSort: true,
          isSortedByManageCorpNum: false,
          isSortedBySubordinateNum: false,
          isSortedByCorpNameKana: false,
          isSortedByResponsibleName: true,
        };
      }
      if (this.isFiltering(this.searchForm)) {
        await this.getFilteredCorporateListFromModal();
      } else {
        await this.getCorporateListFromModal(1);
      }
    },
  }
}
</script>

<style scoped>
.overlay-company-modal {
  display: flex;
  position:fixed;
  align-items: center;
  justify-content: center;
}
</style>
